// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#seasidetms_row_ijc0xt5bz{margin-top:20px}.icon_box_inner img{width:20%}", ""]);
// Exports
module.exports = exports;
